// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { Fragment, useEffect, useState, useRef } from "react";
import Portal from "@material-ui/core/Portal";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "../Alert";
import EngagementForm from "../engagements/EngagementForm";
import { Privileges } from "../../Config";
import { isAccessGranted } from "../utils/utils";

const EditForm = (props) => {
  const [formProps, setFormProps] = useState({
    isAccountDisabled: true,
    isOpportunitySelectAvail: false,
    isSalesSubRegionDisabled: false,
    isProductUnitDisabled: false,
    isBusinessUnitDisabled: false,
    isStartEndDatesDisabled: false,
    isTentativeDateDisabled: true,
    isCustomerContactDisabled: false,
    isBusinessDomainDisabled: true,
    isContractSignedDisabled: true,
    isDescriptionDisabled: true,
    isFetchNewDatesButtonAvail: false,
    isCountryDisabled: false,
    isAllocationTypeDisabled: false,
  });

  const [isMessageBarOpen, setIsMessageBarOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessageType, setAlertMessageType] = useState("error");

  const setMessageBar = (message, isOpen, type) => {
    setAlertMessage(message);
    setIsMessageBarOpen(isOpen);
    setAlertMessageType(type);
  };

  const handleMessageBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setIsMessageBarOpen(false);
    setAlertMessage("");
  };

  const accessGranted = isAccessGranted([
    Privileges.APPROVE_INTERNAL_ENGAGEMENTS_APPROVE,
    Privileges.APPROVE_MARKETING_EVENTS_APPROVE,
  ]);

  return (
    <Fragment>
      <Portal>
        <Snackbar
          open={isMessageBarOpen}
          autoHideDuration={6000}
          onClose={handleMessageBarClose}
        >
          <Alert onClose={handleMessageBarClose} severity={alertMessageType}>
            {alertMessage}
          </Alert>
        </Snackbar>
      </Portal>
      <EngagementForm
        formTitle={"Edit Engagement/Event"}
        isEditMode={true}
        initialFormProps={formProps}
        engagementId={props.match?.params?.id}
        setMessageBar={setMessageBar}
        tabIndex={props.tabIndex}
        buttonLable={accessGranted ? "Confirm and Approve" : "Update"}
        isOnApprovalProcess={true}
      />
    </Fragment>
  );
};

export default EditForm;
